module.exports = __webpack_public_path__ + "img/Group-6971.ab087871.svg";